<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="20"
       height="20"
       viewBox="0 0 18 18"
       aria-labelledby="Yuborish"
       role="presentation"
       :style="styles.buttonText"
  >
    <g>
      <path
        :fill="styles.buttonText.color"
        d="M3.72391 3.05306C3.64021 3.0112 3.54644 2.99366 3.45327 3.00246C3.36009 3.01125 3.27126 3.04601 3.19687 3.1028C3.12248 3.15958 3.06552 3.2361 3.03247 3.32365C2.99941 3.41121 2.9916 3.50628 3.00991 3.59806L4.41291 8.44806C4.43907 8.53844 4.4902 8.61961 4.56043 8.68223C4.63065 8.74485 4.71713 8.78638 4.80991 8.80206L10.4999 9.75506C10.7679 9.80806 10.7679 10.1921 10.4999 10.2451L4.80991 11.1981C4.71713 11.2137 4.63065 11.2553 4.56043 11.3179C4.4902 11.3805 4.43907 11.4617 4.41291 11.5521L3.00991 16.4021C2.9916 16.4938 2.99941 16.5889 3.03247 16.6765C3.06552 16.764 3.12248 16.8405 3.19687 16.8973C3.27126 16.9541 3.36009 16.9889 3.45327 16.9977C3.54644 17.0065 3.64021 16.9889 3.72391 16.9471L16.7239 10.4471C16.8068 10.4055 16.8766 10.3417 16.9253 10.2627C16.9741 10.1838 16.9999 10.0928 16.9999 10.0001C16.9999 9.90728 16.9741 9.81634 16.9253 9.7374C16.8766 9.65845 16.8068 9.59463 16.7239 9.55306L3.72391 3.05306V3.05306Z"
      ></path>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'messages.vue',

  props: {
    styles: {
      type: Object,
      required: true
    }
  }
}
</script>
